import TiclickTable from '@src/design-system/molecules/ticlick-table';
import { useAutomatedRemindersTable } from './use-automated-reminders-table';

export function AutomatedRemindersTable() {
  const { table, actionsTable } = useAutomatedRemindersTable();

  return (
    <TiclickTable
      table={table}
      props={{ searchInputProps: { queryKey: 'name' } }}
      actions={actionsTable}
    />
  );
}
